import { render, staticRenderFns } from "./SalesmanCommission.vue?vue&type=template&id=2b3d0cfd&"
import script from "./SalesmanCommission.vue?vue&type=script&lang=js&"
export * from "./SalesmanCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports